import { DataField } from "@iventis/domain-model/model/dataField";
import { DcasConfigDataField } from "@iventis/domain-model/model/dcasConfigDataField";
import { EventBlockTypeDataFields } from "@iventis/domain-model/model/eventBlockTypeDataFields";

export const convertDataFieldsToDcasDataFields = (dataFields: DataField[]): DcasConfigDataField[] =>
    dataFields.map((df, index) => ({
        dataFieldId: df.id,
        index,
    }));

export const getDcasDataFields = (dataFields: DataField[], updatedDataFields: DataField[], eventBlockDataFields: EventBlockTypeDataFields[]): DataField[] => {
    const dataFieldIds = dataFields.map(({ id }) => id);
    return updatedDataFields.filter(({ id }) => !dataFieldIds.includes(id) || eventBlockDataFields.some((df) => df.dataFieldId === id));
};

export const getDeletedDcasDataFieldIds = (dataFields: DataField[], updatedDataFields: DataField[]) => {
    const dataFieldIds = dataFields.map(({ id }) => id);
    return dataFieldIds.filter((id) => !updatedDataFields.some((df) => df.id === id));
};
